import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from "lucide-react";
import { CLINIC } from "@/data/content";

export default function FindUs() {
  return (
    <section id="find" className="py-20 md:py-32 bg-white" data-testid="find-us">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-12 gap-6 items-end mb-10 md:mb-12">
          <div className="col-span-12 md:col-span-6">
            <div className="eyebrow mb-4">Visit us</div>
            <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-[-0.02em]">
              Opposite L&amp;T Gate, <br /><span className="text-[hsl(var(--primary))]">Andheri East.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-5 md:gap-8">
          <motion.div
            className="col-span-12 md:col-span-7 aspect-[4/3] md:aspect-auto md:min-h-[460px] rounded-2xl md:rounded-3xl overflow-hidden border border-[hsl(var(--line))]"
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9 }}
          >
            <iframe
              title="Calm Dentistry location map"
              src="https://maps.google.com/maps?q=Calm+Dentistry+Saki+Vihar+Road+Andheri+East&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%" height="100%" loading="lazy" style={{ border: 0 }}
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>

          <div className="col-span-12 md:col-span-5 flex flex-col gap-4">
            <InfoCard icon={<MapPin size={18} />} label="Address">
              <div className="text-[15px] leading-relaxed text-[hsl(var(--ink-soft))]" data-testid="info-address">{CLINIC.address}</div>
              <a href={CLINIC.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn-pill btn-outline mt-4 text-[12px] py-2 pr-2 pl-4">Google Maps <span className="arrow" style={{width:24,height:24}}><ArrowUpRight size={12}/></span></a>
            </InfoCard>
            <InfoCard icon={<Phone size={18} />} label="For appointments">
              <div className="flex flex-col gap-1">
                {CLINIC.phones.map((p, i) => (
                  <a key={p} href={`tel:${CLINIC.phoneDial[i]}`} className="link-sweep w-fit text-[hsl(var(--ink))] font-display text-lg" data-testid={`info-phone-${i}`}>{p}</a>
                ))}
              </div>
            </InfoCard>
            <div className="grid grid-cols-2 gap-4">
              <InfoCard compact icon={<Mail size={16} />} label="Email">
                <a href={`mailto:${CLINIC.email}`} className="link-sweep text-[13px] break-all text-[hsl(var(--ink))]" data-testid="info-email">{CLINIC.email}</a>
              </InfoCard>
              <InfoCard compact icon={<Clock size={16} />} label="Hours">
                <div className="text-[13px] text-[hsl(var(--ink))]">{CLINIC.hours}</div>
              </InfoCard>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoCard({ icon, label, children, compact }) {
  return (
    <div className={`card-soft ${compact ? "p-4" : "p-6"}`}>
      <div className="flex items-center gap-2 eyebrow mb-3" style={{color: "hsl(var(--primary-dark))"}}>
        <span className="w-8 h-8 rounded-full bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))] flex items-center justify-center">{icon}</span>
        {label}
      </div>
      {children}
    </div>
  );
}
